// @flow
import * as React from 'react';

type Props = {|
  message: Object,
  messageKey: Key,
  closable?: boolean,
  onClose?: Function
|};

function IndicationMessage(props: Props) {
  return props.closable ? (
    <div className={`indication-alert ${props.message.type}`}>
      <div dangerouslySetInnerHTML={{ __html: props.message.text }} />
      <span
        data-key={props.messageKey}
        className="close-message icon cancel-circled clickable-icon"
        onClick={props.onClose}
      />
    </div>
  ) : (
    <div
      className={`indication-alert ${props.message.type}`}
      dangerouslySetInnerHTML={{ __html: props.message.text }}
    />
  );
}

export default IndicationMessage;
